// admin.js - centralized admin fetch helper (session-based authentication)

export async function adminFetch(path, options = {}) {
  const base = (process.env.REACT_APP_API_BASE || 'http://localhost/handmade-haven').replace(/\/$/, '');

  const headers = {
    'Content-Type': 'application/json',
    ...(options.headers || {}),
  };

  const response = await fetch(`${base}/api/${path}`, {
    ...options,
    headers,
    credentials: 'include', // Include cookies for session-based authentication
  });

  return response;
}


